import { combineReducers } from 'redux'
import createToggleReducer from '../utils/create-toggle-reducer'
import {
  TOGGLE_SOURCE_UPGRADE_REVIEW,
  TOGGLE_SOURCE_UPGRADE_REVIEW_ACK,
  TOGGLE_SOURCE_UPGRADE_CONFIRM,
  RECEIVE_SOURCE_UPGRADE_CONFIRM
} from 'actions'

const initialState = {
  reviewOpened: false,
  reviewAcked: false,
  confirmOpened: false
}

const mainReducer = combineReducers({
  reviewOpened: createToggleReducer(TOGGLE_SOURCE_UPGRADE_REVIEW, initialState.reviewOpened),
  reviewAcked: createToggleReducer(TOGGLE_SOURCE_UPGRADE_REVIEW_ACK, initialState.reviewAcked),
  confirmOpened: createToggleReducer(TOGGLE_SOURCE_UPGRADE_CONFIRM, initialState.confirmOpened)
})

export default (state, action) => {
  switch (action.type) {
    case RECEIVE_SOURCE_UPGRADE_CONFIRM:
      return initialState
    default:
      return mainReducer(state, action)
  }
}



// WEBPACK FOOTER //
// ./reducers/application/source-upgrades.js